import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormContext, FormErrorTypes } from 'dash-ui';

import { FormFields } from './ChangeEmail.constants';
import { isEmailValid, isPasswordValid } from 'dash-common';

const useValidation = () => {
  const { errorHandlers } = useContext(FormContext);
  const { t } = useTranslation(['forms', 'common', 'pages']);

  const validateFieldByName = (fieldName: FormFields, value: string) => {
    const setInvalid = (message: string) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        message: t(message),
      });
    };

    // check specific fields type
    switch (fieldName) {
      case FormFields.Email: {
        if (!isEmailValid(value)) {
          setInvalid('forms:messages.emailInvalid');
          return false;
        }
        break;
      }
      case FormFields.Password: {
        if (!isPasswordValid(value)) {
          setInvalid('forms:messages.passwordInvalid');
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };

  return validateFieldByName;
};

export default useValidation;
